// Favourite devices for quick access. Uses the same inline control cards as the
// room grid â€” 1/2/4-touch show their buttons, fan shows its dial, etc. Device
// types without an inline card open the full control screen.

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, AppBar, Toolbar, Grid, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getFavouriteDevices } from '../../../core/api/api';
import { useApp } from '../../../core/state/AppContext';
import DeviceControlCard from '../components/DeviceControlCard';
import { deviceGridSpan } from '../../../core/devices/deviceMeta';

export default function FavouritesScreen() {
  const { userId } = useApp();
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    const fetchFavs = async (silent) => {
      try {
        const res = await getFavouriteDevices(userId);
        const arr = Array.isArray(res.data) ? res.data : [];
        arr.sort((a, b) => (Number(a.SortOrder ?? 0) || 0) - (Number(b.SortOrder ?? 0) || 0));
        if (alive) setDevices(arr);
      } catch (e) {
        /* ignore */
      } finally {
        if (alive && !silent) setLoading(false);
      }
    };
    fetchFavs(false);
    // Poll every 30s so the online/offline dots stay current (DB updates ~30s).
    const id = setInterval(() => fetchFavs(true), 30000);
    return () => { alive = false; clearInterval(id); };
  }, [userId]);

  // Favourites span multiple locations, so show a "Location - Room" breadcrumb
  // (a device with no room is a location-level common device).
  const breadcrumb = (d) =>
    `${d.LocationName || 'No Location'} - ${d.RoomName || 'Common Device'}`;

  return (
    <Box>
      <AppBar position="static" elevation={2}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate('/home')}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>Favourites</Typography>
          <Box sx={{ width: 40 }} />
        </Toolbar>
      </AppBar>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}><CircularProgress /></Box>
      ) : devices.length === 0 ? (
        <Typography sx={{ textAlign: 'center', mt: 6 }} color="text.secondary">No favourite devices</Typography>
      ) : (
        <Grid container spacing={1.25} alignItems="stretch" sx={{ p: 1.5 }}>
          {devices.map((d) => (
            <Grid item {...deviceGridSpan(d.DeviceID)} key={d.UniqueNumber} sx={{ display: 'flex' }}>
              <Box sx={{ width: '100%' }}>
                <DeviceControlCard device={d} subtitle={breadcrumb(d)} />
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
